import { takeLatest, put, call } from 'redux-saga/effects';

import { findAnimalCadastro } from '../service';
import {
  FIND_ANIMAL_CADASTRO,
  FIND_ANIMAL_CADASTRO_PENDING,
  FIND_ANIMAL_CADASTRO_SUCCESS,
  FIND_ANIMAL_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindAnimalCadastro(action) {
  yield put({ type: FIND_ANIMAL_CADASTRO_PENDING, id: action.id })

  try {
    const registro = yield call(findAnimalCadastro, action.id);
    yield put({ type: FIND_ANIMAL_CADASTRO_SUCCESS, registro: registro })
  } catch (error) {
    yield put({ type: FIND_ANIMAL_CADASTRO_FAILURE })
  }
}

export default function* watchFindAnimalCadastro() {
  yield takeLatest(FIND_ANIMAL_CADASTRO, sagaFindAnimalCadastro)
}
